//商品一覧のサイドバー
$(function () {
    $(".CollectionMenu__List--Link span.plus").on({
      click: function () {
        $(this).toggleClass("active");
        $(this)
          .parent("div")
          .next("ul")
          .slideToggle(400);
        return false;
      },
    });
  });

//外部リンクを別タブで開く
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
    }
  }